export const CURRENT_THEME = process.env.REACT_APP_UI_THEME || 'default'
